'use strict';
module.exports = function hasMissingScopes(grantedScopesString, requiredScopesString) {
	const grantedScopes = (grantedScopesString && grantedScopesString.split(' ')) || [],
		requiredScopes = (requiredScopesString && requiredScopesString.split(' ')) || [],
		missingScope = requiredScopes.find(scope => !grantedScopes.includes(scope));
	return !!missingScope;
};
